

export const getChartDataGenericCall = async (uri, chartid, usercode,filters) => {


    let firstTry = await APICall(10000)
    // console.log('getChartDataGenericCall first', firstTry)
    if (typeof firstTry === "object") {
        return firstTry
    } else {
        let secondTry = await APICall(10000)
        // console.log('getChartDataGenericCall second', secondTry)
        if (typeof secondTry === "object") {
            return secondTry
        } else {
            let thridTry = await APICall(10000)
            // console.log('getChartDataGenericCall third', thridTry)
            if (typeof thirdTry === "object") {
                return thridTry
            } else {
                console.warn("getChartDataGenericCall saw an api call fail 3x")
                return 'failed'
            }
        }
    }

    async function APICall(timeOutValue) {

        return new Promise(function (resolve, reject) {

            let controller = new AbortController();

            let urlEncodedFilters = encodeURIComponent(JSON.stringify(filters))
            let url = uri + "?chartid=" + chartid + "&usercode=" + usercode + "&filters=" + urlEncodedFilters
            let myHeaders = new Headers();
            myHeaders.append("x-api-key", "vdhy8wwjUJrwhxFpfuECTiAW");

            var requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow",
            };

            let request = new Request(url, requestOptions);

            if (timeOutValue) {
                setTimeout(() => controller.abort(), timeOutValue);
            }


            fetch(request)
                .then((response) => {
                    // console.log(
                    //     "debug getChartDataGenericCall.js response",
                    //     response
                    // );
                    if (!response.ok) {
                        console.error(
                            "getChartDataGenericCall.js error",
                            response.statusText,
                            response
                        );
                        throw Error(response.statusText);
                    }
                    return response.json();
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.error("getChartDataGenericCall API Request failed", err, 'ChartId', chartid);
                    resolve(err);
                });
        });
    }
};

export default getChartDataGenericCall